import type { PayloadAction } from "@reduxjs/toolkit"
import { createSlice } from "@reduxjs/toolkit"

export type UiState = {
	openFilePicker: boolean
	continueEditMode: boolean
}

export const initialState: UiState = {
	openFilePicker: false,
	continueEditMode: false,
}

export const uiSlice = createSlice({
	name: "ui",
	initialState,
	reducers: {
		setOpenFilePicker: (state, action: PayloadAction<boolean>) => {
			state.openFilePicker = action.payload
		},
		setContinueEditMode: (state, action: PayloadAction<boolean>) => {
			state.continueEditMode = action.payload
		},
	},
})
